document.addEventListener("DOMContentLoaded", function() {

    let team_member_item  = document.querySelectorAll('.team-members--item');
    let team_member_close = document.querySelectorAll('.team-members--item_modal__inner > .customicon-close');

    team_member_item.forEach((item) => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            let target = this.getAttribute('data-target');
            let modal = document.getElementById('team-member-modal--' + target);
            window.helpers.fadeIn(modal, 'flex');
        });
    });

    team_member_close.forEach((close) => {
        close.addEventListener('click', function(e) {
            e.preventDefault();
            let parent = this.parentElement;
            let wrap = parent.parentElement
            window.helpers.fadeOut(wrap); 
        });
    });

});
